(function () {
  angular.module("akitabox.serviceRequest.create").run(states);

  /* @ngInject */
  function states(Router, models) {
    var queryParams = [
      models.BUILDING.ROUTE_SINGULAR,
      models.FLOOR.ROUTE_SINGULAR,
      models.ROOM.ROUTE_SINGULAR,
      models.ASSET.ROUTE_SINGULAR,
    ].join("&");

    Router.configureStates([
      {
        state: "app.serviceRequests.create",
        config: {
          url: "/create?" + queryParams,
          templateUrl: "app/mobile/modules/service-request/create/create.html",
          controller: "CreateServiceRequestController",
          controllerAs: "vm",
          data: {
            pageTitle: "Create Service Request",
            pushHistory: false,
          },
          params: {
            building: null,
          },
          resolve: {
            building: getBuilding,
            floorId: getFloorId,
            roomId: getRoomId,
            assetId: getAssetId,
          },
        },
      },
    ]);
  }

  /* @ngInject */
  function getBuilding($stateParams, account, models, BuildingService) {
    // Return the building if supplied from another state
    if (angular.isEmpty($stateParams.building)) {
      return null;
    }

    var building = $stateParams.building;

    // IDs have been provided, fetch the building
    return BuildingService.getById(building).catch(function () {
      return null;
    });
  }

  /* @ngInject */
  function getFloorId($stateParams, account, models) {
    return $stateParams[models.FLOOR.ROUTE_SINGULAR];
  }

  /* @ngInject */
  function getRoomId($stateParams, account, models) {
    return $stateParams[models.ROOM.ROUTE_SINGULAR];
  }

  /* @ngInject */
  function getAssetId($stateParams, account, models) {
    return $stateParams[models.ASSET.ROUTE_SINGULAR];
  }
})();
